export default "__VITE_ASSET__BZQ8R9FK__"